// projects/humanresources-personnel/src/assets/i18n/*/hr-per-historical-data.json
export class HrPerHistoricalDataKey {
    private static readonly keyPrefix = 'hrPerHistData';
    public static title = `${HrPerHistoricalDataKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerHistoricalDataKey.keyPrefix}.pageHeader`;
}
